// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ca407f87","885":"a49ef081"}[chunkId] + ".chunk.js";
};